import { render, staticRenderFns } from "./CmgRewardsExtrasBody.vue?vue&type=template&id=7eefba3f&scoped=true&lang=pug"
import script from "./cmg-rewards-extras-body.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-extras-body.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExtrasBody.vue?vue&type=style&index=0&id=7eefba3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eefba3f",
  null
  
)

export default component.exports